var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialsLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#4534C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.846 36.5342H18.68V21.1782H13.846V36.5322V36.5342ZM14.722 18.5752C15.176 18.8822 15.712 19.0482 16.26 19.0512C16.6269 19.0585 16.9916 18.9919 17.3323 18.8553C17.673 18.7188 17.9827 18.515 18.243 18.2563C18.5033 17.9976 18.7089 17.6891 18.8475 17.3493C18.9862 17.0095 19.055 16.6452 19.05 16.2782C19.0505 15.7993 18.927 15.3283 18.6915 14.9113C18.456 14.4942 18.1166 14.1451 17.7063 13.8981C17.296 13.6511 16.8287 13.5144 16.3499 13.5015C15.8711 13.4886 15.3972 13.5998 14.9741 13.8243C14.551 14.0488 14.1933 14.3791 13.9356 14.7828C13.678 15.1866 13.5293 15.6502 13.5039 16.1285C13.4785 16.6067 13.5774 17.0834 13.7908 17.5122C14.0043 17.941 14.3251 18.3072 14.722 18.5752ZM31.666 36.5472H36.498L36.5 27.0492C36.5 22.3592 33.586 20.7592 30.889 20.7592C28.395 20.7592 26.761 22.3732 26.294 23.3182H26.231V21.1902H21.583V36.5472H26.417V28.2202C26.417 26.0002 27.823 24.9202 29.257 24.9202C30.614 24.9202 31.666 25.6832 31.666 28.1572V36.5462V36.5472Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialsLink);
export default __webpack_public_path__ + "static/media/icon_socials_link.43b1262ecf000a974cf3a155826d9af7.svg";
export { ForwardRef as ReactComponent };